<template>
	<div>
		<CheckUserFirstLogin/>
		<Header :currentPage="displayedComponent" />
		<!-- DESKTOP -->
		<div v-if="!isMobile" class="content-user-dashboard">
			<b-container fluid="xl">
				<b-row>
					<b-col class="content-left">
						<UserDashboardNavigate :activeNavigation="displayedComponent" />
					</b-col>
					<b-col class="content-right">
						<div class="wrap-content">
							<Greeting />
							<div class="content-body d-flex">
								<component :is="displayedComponent" />
							</div>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<!-- MOBILE -->
		<div v-else class="user-dashboard-mobile">
			<CheckUserFirstLogin
				v-if="
					displayedComponent != 'UserMain' ||
						profileUser.admin_type.name === 'User'
				"
			/>
			<b-container fluid="xl">
				<b-row>
					<b-col class="pd-0">
						<GreetingMobile
							:isAvatar="isUserMain"
							:isDashboard="isUserMain"
							:isMessage="userSelected ? true : false"
							:titlePage="pageTitle"
							@isBack="handleBackList"
						/>
					</b-col>
					<b-col cols="12">
						<div class="content-body">
							<component
								:is="displayedComponent"
								@userMessageUserSelected="userSelected = $event"
							/>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
import Header from '@/components/ui/header';
import Greeting from '@/components/admin/ui/greeting/Greeting';
import GreetingMobile from '@/components/admin/ui/greetingMobile/GreetingMobile';
import UserDashboardNavigate from '@/components/admin/userDashboard/userDashboardNavigate/UserDashboardNavigate';

import UserMain from '@/components/admin/userDashboard/userMain/UserMain';
import UserMessage from '@/components/admin/common/message/Message';
import Profile from '@/components/admin/common/profile/Profile';
import UserKhaosodCoins from '@/components/admin/userDashboard/userKhaosodCoins/UserKhaosodCoins';
import UserPayment from '@/components/admin/userDashboard/userPayment/UserPayment';
import UserStatistic from '@/components/admin/userDashboard/userStatistic/UserStatistic';
import UserContact from '@/components/admin/userDashboard/userContact/UserContact';
import UserManageListing from '@/components/admin/userDashboard/userManageListing/UserManageListing';
import CheckUserFirstLogin from '@/components/admin/utilities/CheckUserFirstLogin';
import UserManageAgents from '@/components/admin/userDashboard/userManageAgents/UserManageAgents';

import { mapGetters, mapActions, mapState } from 'vuex';

import $ from 'jquery';

export default {
	components: {
		Header,
		Greeting,
		GreetingMobile,
		UserDashboardNavigate,
		UserMain,
		UserMessage,
		Profile,
		UserKhaosodCoins,
		UserPayment,
		UserStatistic,
		UserContact,
		UserManageListing,
		CheckUserFirstLogin,
		UserManageAgents
	},
	data() {
		return {
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: null,
			displayedComponent: 'UserMain',
			userSelected: null,
			pageTitles: {
				UserMessage: this.$t('userDashboard.messages.textBox'),
				Profile: this.$t('userDashboard.navigation.mobile.profile'),
				UserManageListing: this.$t('userDashboard.navigation.mylisting'),
				UserPayment: this.$t('userDashboard.navigation.payment'),
				UserKhaosodCoins: this.$t('userDashboard.navigation.coins'),
				UserContact: this.$t('userDashboard.navigation.contactAndReport')
			},

			socket: null
		};
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		isUserMain() {
			return this.displayedComponent === 'UserMain' ? true : false;
		},
		pageTitle() {
			return this.pageTitles[this.displayedComponent];
		}
	},
	watch: {
		$route(newVal) {
			this.displayedComponent = newVal.name;
		}
	},
	created() {
		this.displayedComponent = this.$route.name;
	},
	methods: {
		handleBackList() {
			this.userSelected = null;
		}
	}
};
</script>
<style lang="scss">
@import 'userDashboard.scss';
</style>
